import { Injectable } from '@angular/core';
import { DataCollectionsShareModel } from '@osos/shared/api';
import { SharedCollectionPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class SharedCollectionParserV1Service extends ParserBase<
  DataCollectionsShareModel,
  SharedCollectionPresenterModel
> {
  constructor() {
    super(DataCollectionsShareModel, SharedCollectionPresenterModel, 1);
  }

  override getPresenterModel(
    model: Partial<DataCollectionsShareModel>,
  ): SharedCollectionPresenterModel {
    throw new Error('Method not implemented.');
  }

  getDataModel(
    presenter: SharedCollectionPresenterModel,
  ): DataCollectionsShareModel {
    const model = {
      authenticated: presenter.authenticated,
      sharedTo: presenter.sharedTo,
    } as DataCollectionsShareModel;
    return model;
  }
}
